"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _partial = _interopRequireDefault(require("react-utils/partial"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _H = _interopRequireDefault(require("../elements/headings/H4"));

var _H2 = _interopRequireDefault(require("../elements/headings/H7"));

var _Color = require("../core/Color");

var _Small = _interopRequireDefault(require("../elements/Small"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIButtonWrapper = _interopRequireDefault(require("../layout/UIButtonWrapper"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _UIImage = _interopRequireDefault(require("../image/UIImage"));

var _UINextButton = _interopRequireDefault(require("../button/UINextButton"));

var _UIPreviousButton = _interopRequireDefault(require("../button/UIPreviousButton"));

var _sizes = require("HubStyleTokens/sizes");

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Styles = require("../utils/Styles");

var _underscore = require("../utils/underscore");

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

function _templateObject15() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: auto;\n  left: 50%;\n  min-height: 100%;\n  min-width: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: auto;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 0;\n  overflow: hidden;\n\n  /*\n  * based on the 110 x 76 dimensions in the mocks, this creates an intrinsic\n  * ratio for thumbnails by setting the top padding in the style of the\n  * time-honored aspect ratio trick. This is a nested wrapper because older\n  * versions of Edge and Firefox do not honor percentage values for padding\n  * on flex-children: https://stackoverflow.com/a/23754080\n  * */\n  padding-top: calc(100% * ", ");\n  position: relative;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex: 0 1;\n  flex-basis: calc(20% - ", ");\n  border-radius: ", ";\n  box-shadow: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: block;\n  margin: 0 8px;\n  text-align: center;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  grid-area: footer;\n  padding: 0 ", ";\n\n  @supports (display: grid) {\n    margin-right: 0;\n    padding: 0;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-self: center;\n  flex-basis: ", ";\n  grid-area: prev;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-self: center;\n  flex-basis: ", ";\n  grid-area: next;\n  text-align: right; /* for fallback layout */\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  > :last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-basis: calc(100% - ", ");\n  grid-area: contents;\n  margin-bottom: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  grid-area: callout;\n  margin-bottom: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n  text-align: center;\n\n  @supports (display: grid) {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  @media only screen and (max-width: ", ") {\n    margin-top: ", ";\n    padding-left: 0;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: 12px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: 0 auto;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  grid-area: header;\n  margin-bottom: 24px;\n  text-align: center;\n\n  @supports (display: grid) {\n    margin-right: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-wrap: wrap;\n  grid-column-gap: ", ";\n  grid-template-areas: ", ";\n  grid-template-columns: auto 1fr auto;\n  max-width: ", ";\n  padding: ", ";\n  padding-top: 0;\n  position: relative;\n\n  > * {\n    flex: 1 1 100%;\n  }\n\n  @supports (display: grid) {\n    display: grid;\n  }\n\n  @media only screen and (max-width: ", ") {\n    grid-template-areas: ", ";\n    grid-template-columns: auto 1fr auto;\n\n    && > * {\n      margin-right: 0;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var preloadImages = function preloadImages(steps) {
  steps.forEach(function (step) {
    if (step.image) {
      var img = new Image();
      img.src = step.image;
    }
  });
};

var DEFAULT_MAX_WIDTH = 826; // width + gutters

var GUTTER_SIZE = 20;
var MAX_THUMBNAILS = 5;
var THUMBNAIL_ASPECT_RATIO = 0.6909090909;
/* based on 76/110 spec */

var THUMBNAIL_GAP = 24;
var FLEX_FALLBACK_SPACE = parseInt(_sizes.BUTTON_SM_WIDTH, 10) + GUTTER_SIZE;
var STACKED_LAYOUT = "\n  'header header    header  '\n  '.      steps     .       '\n  'prev   contents  next    '\n  '.      callout   .       '\n  '.      footer    .       '\n";
var RESPONSIVE_LAYOUT = "\n  'header     header      header  '\n  'steps      steps       steps   '\n  'contents   contents    contents'\n  'prev       footer      next    '\n  'callout    callout     callout '\n";

var CarouselWrapper = _styledComponents.default.section.withConfig({
  displayName: "UICarousel__CarouselWrapper",
  componentId: "sc-196iax7-0"
})(_templateObject(), (0, _Styles.toPx)(GUTTER_SIZE), STACKED_LAYOUT, function (props) {
  return (0, _Styles.toPx)(props.maxWidth);
}, (0, _Styles.toPx)(GUTTER_SIZE), _sizes.GRID_BREAKPOINT_SMALL, RESPONSIVE_LAYOUT);

var CarouselHeader = _styledComponents.default.div.withConfig({
  displayName: "UICarousel__CarouselHeader",
  componentId: "sc-196iax7-1"
})(_templateObject2());

var CarouselImage = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "UICarousel__CarouselImage",
  componentId: "sc-196iax7-2"
})(_templateObject3());
var CarouselTitle = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "UICarousel__CarouselTitle",
  componentId: "sc-196iax7-3"
})(_templateObject4());
var CarouselSubtitle = (0, _styledComponents.default)(_H2.default).withConfig({
  displayName: "UICarousel__CarouselSubtitle",
  componentId: "sc-196iax7-4"
})(_templateObject5());

var CarouselCallout = _styledComponents.default.aside.withConfig({
  displayName: "UICarousel__CarouselCallout",
  componentId: "sc-196iax7-5"
})(_templateObject6(), (0, _Styles.toPx)(GUTTER_SIZE), (0, _Styles.toPx)(FLEX_FALLBACK_SPACE), (0, _Styles.toPx)(FLEX_FALLBACK_SPACE), _sizes.GRID_BREAKPOINT_SMALL, (0, _Styles.toPx)(GUTTER_SIZE));

var CarouselContent = _styledComponents.default.section.withConfig({
  displayName: "UICarousel__CarouselContent",
  componentId: "sc-196iax7-6"
})(_templateObject7(), (0, _Styles.toPx)(FLEX_FALLBACK_SPACE * 2), (0, _Styles.toPx)(GUTTER_SIZE));

var CarouselContentInner = _styledComponents.default.div.withConfig({
  displayName: "UICarousel__CarouselContentInner",
  componentId: "sc-196iax7-7"
})(_templateObject8());

var CarouselNext = _styledComponents.default.div.withConfig({
  displayName: "UICarousel__CarouselNext",
  componentId: "sc-196iax7-8"
})(_templateObject9(), (0, _Styles.toPx)(FLEX_FALLBACK_SPACE));

var CarouselPrevious = _styledComponents.default.div.withConfig({
  displayName: "UICarousel__CarouselPrevious",
  componentId: "sc-196iax7-9"
})(_templateObject10(), (0, _Styles.toPx)(FLEX_FALLBACK_SPACE));

var CarouselFooter = _styledComponents.default.footer.withConfig({
  displayName: "UICarousel__CarouselFooter",
  componentId: "sc-196iax7-10"
})(_templateObject11(), (0, _Styles.toPx)(FLEX_FALLBACK_SPACE));

var CarouselCurrent = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "UICarousel__CarouselCurrent",
  componentId: "sc-196iax7-11"
})(_templateObject12());
var CarouselThumbnail = (0, _styledComponents.default)(_UIClickable.default).withConfig({
  displayName: "UICarousel__CarouselThumbnail",
  componentId: "sc-196iax7-12"
})(_templateObject13(), (0, _Styles.toPx)(THUMBNAIL_GAP), _sizes.BUTTON_RADIUS, function (props) {
  return props['aria-current'] ? "\n        0 0 0 2px " + _colors.CALYPSO + ",\n        0 0 12px 0 " + (0, _Color.rgba)(_colors.CALYPSO, 0.5) + "\n      " : "0 0 0 1px " + _colors.CALYPSO_MEDIUM;
});

var AspectRatioBox = _styledComponents.default.div.withConfig({
  displayName: "UICarousel__AspectRatioBox",
  componentId: "sc-196iax7-13"
})(_templateObject14(), THUMBNAIL_ASPECT_RATIO);

var CarouselThumbnailImage = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "UICarousel__CarouselThumbnailImage",
  componentId: "sc-196iax7-14"
})(_templateObject15());
var USE_OPTIONS = ['max', 'lite'];

var isValidStepIndex = function isValidStepIndex(stepIndex, steps) {
  return !(stepIndex < 0 || stepIndex > steps.length - 1);
};

var getMaxIndex = function getMaxIndex(arr) {
  return arr.length - 1;
};

var UICarousel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UICarousel, _Component);

  function UICarousel() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UICarousel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UICarousel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClickPreviousStep = function () {
      var _this$props = _this.props,
          allowStepLoop = _this$props.allowStepLoop,
          stepIndex = _this$props.stepIndex,
          steps = _this$props.steps;
      var computedStepIndex = isValidStepIndex(stepIndex, steps) ? stepIndex : 0;
      var newIndex;

      if (allowStepLoop && computedStepIndex === 0) {
        newIndex = getMaxIndex(steps);
      } else {
        newIndex = computedStepIndex - 1;
      }

      if (newIndex >= 0) {
        _this.handleChange(newIndex);
      }
    };

    _this.handleClickNextStep = function () {
      var _this$props2 = _this.props,
          allowStepLoop = _this$props2.allowStepLoop,
          stepIndex = _this$props2.stepIndex,
          steps = _this$props2.steps;
      var computedStepIndex = isValidStepIndex(stepIndex, steps) ? stepIndex : 0;
      var newIndex;

      if (allowStepLoop && getMaxIndex(steps) === computedStepIndex) {
        newIndex = 0;
      } else {
        newIndex = computedStepIndex + 1;
      }

      if (newIndex <= getMaxIndex(steps)) {
        _this.handleChange(newIndex);
      }
    };

    _this.handleChange = function (newIndex) {
      _this.props.onStepIndexChange((0, _SyntheticEvent.default)(newIndex));
    };

    _this.handleKeyDown = function (evt) {
      if (evt.key === 'ArrowRight') {
        _this.handleClickNextStep();
      }

      if (evt.key === 'ArrowLeft') {
        _this.handleClickPreviousStep();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(UICarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var steps = this.props.steps;
      preloadImages(steps);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var steps = this.props.steps;
      preloadImages(steps);
    }
  }, {
    key: "renderCount",
    value: function renderCount(steps, computedStepIndex) {
      var totalSteps = steps.length;
      var currentStepDisplayNumber = computedStepIndex + 1;
      return _react.default.createElement(CarouselCurrent, {
        use: "help"
      }, _react.default.createElement("span", {
        className: "sr-only"
      }, _I18n.default.text('ui.UICarousel.current', {
        currentStepDisplayNumber: currentStepDisplayNumber,
        totalSteps: totalSteps
      })), _react.default.createElement("span", {
        "aria-hidden": true
      }, currentStepDisplayNumber + "/" + totalSteps));
    }
  }, {
    key: "renderFooter",
    value: function renderFooter(allowStepLoop, use, steps, computedStepIndex) {
      var totalSteps = steps.length;
      var renderedCount = allowStepLoop ? null : this.renderCount(steps, computedStepIndex);
      var renderedFooter;
      renderedFooter = renderedCount;

      if (use === 'max') {
        renderedFooter = totalSteps > MAX_THUMBNAILS ? renderedCount : this.renderThumbnails(steps, computedStepIndex);
      }

      return _react.default.createElement(CarouselFooter, {
        use: use
      }, renderedFooter);
    }
  }, {
    key: "renderThumbnails",
    value: function renderThumbnails(steps, computedStepIndex) {
      var _this2 = this;

      var totalThumbs = steps;
      var thumbs = totalThumbs.map(function (step, i) {
        if (!step.image) return null;
        var isCurrentStep = computedStepIndex === i || undefined;
        return _react.default.createElement(CarouselThumbnail, {
          "aria-current": isCurrentStep,
          key: i,
          onClick: (0, _partial.default)(_this2.handleChange, i)
        }, _react.default.createElement(AspectRatioBox, null, _react.default.createElement(CarouselThumbnailImage, {
          alt: step.alt,
          src: step.image
        })));
      });
      return _react.default.createElement(_UIButtonWrapper.default, {
        alignItems: "start",
        horizontalGap: THUMBNAIL_GAP
      }, thumbs);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          allowStepLoop = _this$props3.allowStepLoop,
          Heading = _this$props3.Heading,
          id = _this$props3.id,
          imageHeight = _this$props3.imageHeight,
          MainContent = _this$props3.MainContent,
          maxWidth = _this$props3.maxWidth,
          __onStepIndexChange = _this$props3.onStepIndexChange,
          stepIndex = _this$props3.stepIndex,
          steps = _this$props3.steps,
          titleText = _this$props3.titleText,
          use = _this$props3.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["allowStepLoop", "Heading", "id", "imageHeight", "MainContent", "maxWidth", "onStepIndexChange", "stepIndex", "steps", "titleText", "use"]);
      var computedStepIndex = isValidStepIndex(stepIndex, steps) ? stepIndex : 0;
      this._id = this._id || (0, _underscore.uniqueId)('carousel');
      var computedId = id || this._id;
      var describedById = computedId + "-desc";
      var currentStep = steps[computedStepIndex];
      var isFirstStep = computedStepIndex === 0;
      var isLastStep = computedStepIndex === getMaxIndex(steps);
      return _react.default.createElement(CarouselWrapper, (0, _extends2.default)({}, rest, {
        "aria-atomic": true,
        "aria-describedby": describedById,
        "aria-live": "polite",
        id: computedId,
        onKeyDown: this.handleKeyDown,
        maxWidth: maxWidth,
        tabIndex: 0,
        use: use
      }), _react.default.createElement(CarouselHeader, {
        use: use
      }, titleText && _react.default.createElement(Heading, null, titleText), _react.default.createElement("div", {
        "aria-hidden": true,
        className: "sr-only",
        id: describedById
      }, _I18n.default.text('ui.UICarousel.tip'))), _react.default.createElement(CarouselPrevious, null, _react.default.createElement(_UIPreviousButton.default, {
        "aria-controls": computedId,
        "aria-hidden": true,
        "aria-label": _I18n.default.text('ui.UICarousel.prev'),
        onClick: this.handleClickPreviousStep,
        disabled: isFirstStep && !allowStepLoop,
        size: "sm"
      })), _react.default.createElement(CarouselContent, {
        use: use
      }, _react.default.createElement(MainContent, null, currentStep.image ? _react.default.createElement(CarouselImage, {
        alt: currentStep.alt,
        objectFit: "contain",
        shape: "rounded",
        src: currentStep.image,
        style: {
          height: imageHeight
        }
      }) : currentStep.content)), _react.default.createElement(CarouselNext, null, _react.default.createElement(_UINextButton.default, {
        "aria-controls": computedId,
        "aria-hidden": true,
        "aria-label": _I18n.default.text('ui.UICarousel.next'),
        onClick: this.handleClickNextStep,
        disabled: isLastStep && !allowStepLoop,
        size: "sm"
      })), currentStep.description && _react.default.createElement(CarouselCallout, {
        use: use
      }, currentStep.name && _react.default.createElement(CarouselSubtitle, {
        role: "presentation"
      }, currentStep.name), currentStep.description), this.renderFooter(allowStepLoop, use, steps, computedStepIndex));
    }
  }]);
  return UICarousel;
}(_react.Component);

UICarousel.propTypes = {
  allowStepLoop: _propTypes.default.bool.isRequired,
  defaultStepIndex: _propTypes.default.number,
  Heading: RenderProp.getPropType(_H.default),
  imageHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  MainContent: _propTypes.default.elementType,
  maxWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  onStepIndexChange: _propTypes.default.func,
  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
    alt: _propTypes.default.string,
    name: _propTypes.default.string,
    description: _propTypes.default.node,
    content: _propTypes.default.node,
    image: _propTypes.default.string
  })),
  stepIndex: _propTypes.default.number,
  titleText: _propTypes.default.node,
  use: _propTypes.default.oneOf(USE_OPTIONS)
};
UICarousel.defaultProps = {
  allowStepLoop: false,
  MainContent: CarouselContentInner,
  maxWidth: DEFAULT_MAX_WIDTH,
  Heading: CarouselTitle,
  stepIndex: 0,
  use: 'lite'
};
UICarousel.displayName = 'UICarousel';

var _default = (0, _Controllable.default)(UICarousel, ['stepIndex']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/carousel/UICarousel.js
// module id = 800
// module chunks = 209 210 211 212